/* eslint-disable angular/document-service */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const Modal = ({
    isOpened, onCloseDialog, ctaClick, title, description, callout, cancelBtnTxt = 'Cancel', continueBtnTxt = 'Continue',
}) => ReactDOM.createPortal(
    <>
        {isOpened && (
            <>
                <div id='popupContainer' className='tv-overlay overlay-form '>
                    <div
                        id='backdrop'
                        className='tv-overlay__backdrop'
                        data-a11y-dialog-hide='true'
                    ></div>
                    <div className='tv-overlay__content-wrapper' role='document'>
                        <div className='tv-overlay__header'>
                            <button
                                className='btn btn--ghost btn--close'
                                onClick={onCloseDialog}
                                aria-label='Close dialog'
                            >
                                <svg
                                    className='tv-icon close'
                                    xmlns='http://www.w3.org/2000/svg'
                                    viewBox='0 0 24 24'
                                    aria-hidden="true"
                                >
                                    <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' />
                                    <path d='M0 0h24v24H0z' fill='none' />
                                </svg>
                            </button>
                        </div>
                        <div className='tv-overlay__content'>
                            <h1 className="tv-overlay__header-text">
                                {title}
                            </h1>

                            <div style={{ color: 'black', fontSize: 12, margin: '20px 0' }}>
                                {description}
                            </div>

                            { callout
                                ? <div className="text-align-left modal-callout font-size-14px margin-b-16px">
                                    {callout}
                                </div>
                                : null
                            }

                            <div className='tv-overlay__message'>
                                <div
                                    id='overlay-message-buttons'
                                    className='tv-overlay__action'
                                >
                                    <button
                                        type='button'
                                        className='btn btn--cancel margin-r-16px'
                                        onClick={onCloseDialog}
                                    >
                                        {cancelBtnTxt}
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn--primary'
                                        onClick={ctaClick}
                                    >
                                        {continueBtnTxt}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}
    </>,
    document.body,
);

Modal.propTypes = {
    isOpened: PropTypes.bool,
    isAllCheck: PropTypes.bool,
    onCloseDialog: PropTypes.func,
    ctaClick: PropTypes.func,
    title: PropTypes.string,
    content: PropTypes.string,
    callout: PropTypes.string,
    cancelBtnTxt: PropTypes.string,
    continueBtnTxt: PropTypes.string,
};

export default Modal;
